import FocusedMarketList from "./FocusedMarketList.container";

export default FocusedMarketList;
